var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"col-12 text-left"},[_c('m-a',{attrs:{"href":{name:'Chats'}}},[_c('button',{staticClass:"btn btn-success d-inline-block px-3 rounded-pill",attrs:{"type":"button"}},[_vm._v(" همه چت ها ")])])],1),_c('div',{staticClass:"col-12"},[_c('chat-form',{attrs:{"submitFunction":_vm.startNewChatWrapper}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }